export enum LOADERS {
  GET_MEMBERS = 'GET_MEMBERS',
  GET_MESSAGES = 'GET_MESSAGES',
  SET_CODE = 'SET_CODE',
  SET_PHONE = 'SET_PHONE'
}